export default __webpack_public_path__ + "static/media/mahashashanlogo.365aec1fc79fb33cb6d6121d27d1f804.webp";